var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 138,
    viewBox: "0 0 47 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.8228 1.5H45.5V136.5H21.7915V27.2593V24.7318L19.5729 25.9426C18.6293 26.4576 17.2698 27.0499 15.4627 27.7164C13.7176 28.2884 11.8067 28.9712 9.73116 29.7636C7.66173 30.4416 5.70324 31.1205 3.85603 31.8004C2.99152 32.0663 2.20533 32.3226 1.5 32.5696V16.2677L6.19836 13.96C8.64055 12.8174 11.1962 11.562 13.865 10.1942C16.5726 8.80641 19.1095 7.30041 21.4744 5.67519C23.6834 4.22756 25.4787 2.83709 26.8228 1.5Z",
    stroke: "#767676",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.eac2d29d6db429e2a41d4ed230b2c2b3.svg";
export { ForwardRef as ReactComponent };